import { Icon } from '@/ui';

function truncate(s: string, n: number): string {
  const t = s.trim();
  return t.length > n ? t.slice(0, n - 1).trimEnd() + '…' : t;
}

interface Props {
  slug: string;
  title: string;
  seoTitle: string;
  seoDescription: string;
  summary: string;
}

export function SerpPreview({ slug, title, seoTitle, seoDescription, summary }: Props) {
  const shownTitle = truncate(seoTitle || title || 'Titel des Beitrags', 60);
  const shownDesc = truncate(seoDescription || summary || 'Die Beschreibung erscheint hier als Suchergebnis-Snippet.', 155);
  const path = slug ? `blog › ${slug}` : 'blog';
  return (
    <div style={{ border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: 16, background: 'var(--surface-page)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8, color: 'var(--text-200)', fontSize: 12 }}>
        <Icon name="search" size={13} /> Google-Vorschau
      </div>
      <div style={{ fontFamily: 'arial, sans-serif' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
          <span style={{ width: 26, height: 26, borderRadius: '50%', background: '#e8eaed', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#5f6368', fontSize: 12, fontWeight: 700, flex: 'none' }}>A</span>
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontSize: 14, color: '#202124' }}>Aria Robotics</div>
            <div style={{ fontSize: 12.5, color: '#4d5156' }}>aria-robotics.xyz<span style={{ color: '#5f6368' }}> › {path}</span></div>
          </div>
        </div>
        <div style={{ fontSize: 20, lineHeight: 1.3, color: '#1a0dab', marginTop: 4, cursor: 'pointer' }}>{shownTitle}</div>
        <div style={{ fontSize: 14, lineHeight: 1.45, color: '#4d5156', marginTop: 3 }}>{shownDesc}</div>
      </div>
    </div>
  );
}
